import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smoothly scrolls the page to the top on every route change so the
 * visitor doesn't land somewhere mid-page after clicking a link in
 * the footer or the menu. Pure side-effect component (renders null).
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname, search]);
  return null;
}
